import { CIActionGuard, useUserPermission } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { requiredAuthPermission } from '../../../common/constants/UserPermissionConstants';
import { journeyBuilderRoutes } from '../../../journey-builder/constants/JdRoutes';
import classes from './DescriptionText.module.scss';

const DescriptionText = () => {
  const { t: translate } = useTranslation();
  const { permissionObject } = useUserPermission();

  return (
    <div className={classes.container}>
      <div className={classes['body-content']}>
        <div className={classes['body-text']}>
          <span className={classes['body-text-bold']}>
            {translate('description_component.service_header')}
          </span>
          <span>
            {translate('description_component.body_desc5')}
          </span>
          <span className={classes['body-text-bold']}>
            {translate('description_component.event_header')}
          </span>
          <span>
            {translate('description_component.desc_subtitle')}
          </span>
          {CIActionGuard([requiredAuthPermission.Events.edit, requiredAuthPermission.Events.approve], permissionObject.permission) ? (
            <Link to="/control-plane/events/createEvent" state={{ creatreNewEventButtonClicked: true, index: null, from: '/control-plane/dashboard' }}>
              <span className={classes['txt-two']} data-testid="create-event-link">
                {translate('description_component.body_desc4')}
              </span>
            </Link>)
            : (
              <span data-testid="create-event-link-without-nav">
                {translate('description_component.body_desc4')}
              </span>)}
          <span>
            {translate('description_component.body_desc5')}
          </span>
          {CIActionGuard([requiredAuthPermission.Services.edit, requiredAuthPermission.Services.approve], permissionObject.permission) ? (
            <Link to="/control-plane/services/createService" state={{ creatreNewEventButtonClicked: true, from: '/control-plane/dashboard' }}>
              <span className={classes['txt-two']} data-testid="create-service-link">
                {translate('description_component.body_desc6')}
              </span>
            </Link>)
            : (
              <span data-testid="create-service-link-without-nav">
                {translate('description_component.body_desc6')}
              </span>
            )}
          <span>
            {translate('description_component.body_desc7')}
          </span>
          <span>
            {translate('description_component.body_desc8')}
          </span>
          {CIActionGuard([requiredAuthPermission.JD.edit, requiredAuthPermission.JD.approve], permissionObject.permission) ? (
            <Link to={journeyBuilderRoutes.createJourney} state={{ creatreNewEventButtonClicked: true, from: '/control-plane/dashboard' }}>
              <span className={classes['txt-two']} data-testid="create-journey-link">
                {translate('description_component.body_desc9')}
              </span>
            </Link>)
            : (
              <span data-testid="create-journey-link-without-nav">
                {translate('description_component.body_desc9')}
              </span>
          )}
          <span>
            {translate('description_component.body_desc10')}
          </span>
          <span className={classes['body-text-bold']}>
            {translate('description_component.body_desc11')}
          </span>
          <span>
            {translate('description_component.body_desc12')}
          </span>
        </div>
      </div>
    </div>
  );
};
export default DescriptionText;
